<template>
  <v-container>
    <v-layout align-center justify-center>
      <v-card class="font-weight-light" width="450">
        <v-card-title>
          <h4>(A) MÓDULO 01 – Composição da Remuneração</h4>
        </v-card-title>
      </v-card>
      <v-card class="ml-2" color="light-blue lighten-2" dark light width="170">
        <v-card-text>
          <h3> {{ amountOfModuleOne | currency }} </h3>
        </v-card-text>
      </v-card>
    </v-layout>

    <v-layout class="mt-3" align-center justify-center>
      <v-card class="font-weight-light" width="450">
        <v-card-title>
          <h4>(B) MÓDULO 02 –Encargos e benefícios anuais, mensais e diários</h4>
        </v-card-title>
      </v-card>
      <v-card class="ml-2" color="light-blue lighten-2" dark light width="170">
        <v-card-text>
          <h3> {{ amountOfModuleTwo | currency }} </h3>
        </v-card-text>
      </v-card>
    </v-layout>

    <v-layout class="mt-3" align-center justify-center>
      <v-card class="font-weight-light" width="450">
        <v-card-title>
          <h4>(C) MÓDULO 03 – Provisão para rescisão</h4>
        </v-card-title>
      </v-card>
      <v-card class="ml-2" color="light-blue lighten-2" dark light width="170">
        <v-card-text>
          <h3> {{ amountOfModuleThree | currency }} </h3>
        </v-card-text>
      </v-card>
    </v-layout>

    <v-layout class="mt-3" align-center justify-center>
      <v-card class="font-weight-light" width="450">
        <v-card-title>
          <h4>(D) MÓDULO 04 – Custo de reposiçao do profissional ausente</h4>
        </v-card-title>
      </v-card>
      <v-card class="ml-2" color="light-blue lighten-2" dark light width="170">
        <v-card-text>
          <h3> {{ amountOfModuleFour | currency }} </h3>
        </v-card-text>
      </v-card>
    </v-layout>

    <v-layout class="mt-3" align-center justify-center>
      <v-card class="font-weight-light" width="450">
        <v-card-title>
          <h4>(E) MÓDULO 05 – Insumos diversos</h4>
        </v-card-title>
      </v-card>
      <v-card class="ml-2" color="light-blue lighten-2" dark light width="170">
        <v-card-text>
          <h3> {{ amountOfModuleFive | currency }} </h3>
        </v-card-text>
      </v-card>
    </v-layout>

    <v-layout class="mt-5 mb-5" align-center justify-center>
      <v-card class="font-weight-light" width="450">
        <v-card-title>
          <h4>SUBTOTAL (A+B+C+D+E)</h4>
        </v-card-title>
      </v-card>
      <v-card class="ml-2" color="light-blue lighten-2" dark light width="170">
        <v-card-text>
          <h3> {{ subTotal | currency }} </h3>
        </v-card-text>
      </v-card>
    </v-layout>

    <v-layout align-center justify-center>
      <v-card class="font-weight-light" width="450">
        <v-card-title>
          <h4>(F) MÓDULO 06 – Custos Indireto, Lucros e Tributos</h4>
        </v-card-title>
      </v-card>
      <v-card class="ml-2" color="light-blue lighten-2" dark light width="170">
        <v-card-text>
          <h3> {{ amountOfModuleSix | currency }} </h3>
        </v-card-text>
      </v-card>
    </v-layout>

    <v-layout class="mt-3" align-center justify-center>
      <v-card class="font-weight-light" width="450">
        <v-card-title>
          <h4>VALOR TOTAL PROPOSTO POR EMPREGADO</h4>
        </v-card-title>
      </v-card>
      <v-card class="ml-2" color="light-blue lighten-2" dark light width="170">
        <v-card-text>
          <h3> {{ total | currency }} </h3>
        </v-card-text>
      </v-card>
    </v-layout>

    <v-layout class="mt-3" align-center justify-center>
      <v-card class="font-weight-light" width="450">
        <v-card-title>
          <h4>{{numberOfEmployees}} EMPREGADO(S)</h4>
        </v-card-title>
      </v-card>
      <v-card class="ml-2" color="light-blue lighten-2" dark light width="170">
        <v-card-text>
          <h3> {{ finalValue | currency }} </h3>
        </v-card-text>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
  import {mapState} from "vuex";
  export default {

    name: "TabSummaryTable",

    computed: {
      numberOfEmployees(){
        if (this.analyticalWorksheet && this.analyticalWorksheet.header)
          return this.analyticalWorksheet.header.numberOfEmployees
        return 0
      },
      finalValue(){
        return this.total * this.numberOfEmployees
      },
      subTotal() {
        return  this.amountOfModuleOne +
                this.amountOfModuleTwo +
                this.amountOfModuleThree +
                this.amountOfModuleFour +
                this.amountOfModuleFive
      },
      total() {
        let amount = this.subTotal + this.amountOfModuleSix;

        if (this.analyticalWorksheet && this.analyticalWorksheet.header)
          this.analyticalWorksheet.header.amountMonthly = amount
        
        return amount;
      },
      
      ...mapState({amountOfModuleOne  : state => state.budget.amountOfModuleOne}),
      ...mapState({amountOfModuleTwo  : state => state.budget.amountOfModuleTwo}),
      ...mapState({amountOfModuleThree: state => state.budget.amountOfModuleThree}),
      ...mapState({amountOfModuleFour : state => state.budget.amountOfModuleFour}),
      ...mapState({amountOfModuleFive : state => state.budget.amountOfModuleFive}),
      ...mapState({amountOfModuleSix  : state => state.budget.amountOfModuleSix}),
      ...mapState({analyticalWorksheet: state => state.budget.analyticalWorksheet})
    },
  }

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/budget/TabSummaryTable.vue